export default "__VITE_ASSET__BTI8$GFK__"